<template>
  <l-map
    v-if="parcelshopList.length > 0"
    class="map hidden-xs"
    :zoom="zoom"
    :options="mapOptions"
    :center="center"
    @update:center="centerUpdate"
    @dblclick="findNearestParcelshops"
    ref="map"
  >
    <l-tile-layer :url="url" :attribution="attribution" />
    <v-marker-cluster :options="{ showCoverageOnHover: false }">
      <l-marker
        v-for="parcelshop in parcelshopList"
        :key="parcelshop.Numero"
        :lat-lng="computeCoordinates(parcelshop)"
        @click="focusParcelshop(parcelshop.Numero)"
      >
        <l-icon :icon-size="[45, 45]">
          <div
            v-if="isAmazonLocker(parcelshop)"
            v-show="isVisible(parcelshop)"
            :class="pictoHighlightClass(parcelshop)"
          >
            <AmazonLockerIcon />
          </div>
          <div
            v-else-if="parcelshop.CodeNature == 'C'"
            v-show="isVisible(parcelshop)"
            :class="pictoHighlightClass(parcelshop)"
          >
            <LockerIcon />
          </div>
          <div
            v-else
            v-show="isVisible(parcelshop)"
            :class="pictoHighlightClass(parcelshop)"
          >
            <ParcelshopIcon />
          </div>
        </l-icon>
      </l-marker>
    </v-marker-cluster>
  </l-map>
</template>

<script>
import "leaflet/dist/leaflet.css";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";
import { Icon } from "leaflet";
import { mapState } from "vuex";
import Vue2LeafletMarkerCluster from "vue2-leaflet-markercluster";
import LockerIcon from "../Icon/Locker/LockerIcon.vue";
import AmazonLockerIcon from "../Icon/AmazonLocker/AmazonLockerIcon.vue";
import { isAmazonLocker, isLocker } from "../../utils/amazonLocker";
import ParcelshopIcon from "../Icon/Parcelshop/ParcelshopIcon.vue";
import L from "leaflet";

// Correction du bug des spots indispo leaflet
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  components: {
    "v-marker-cluster": Vue2LeafletMarkerCluster,
    LIcon,
    LMap,
    LMarker,
    LockerIcon,
    AmazonLockerIcon,
    LTileLayer,
    ParcelshopIcon,
  },
  props: {
    parcelshopList: Array,
  },
  data() {
    return {
      zoom: 13,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      mapOptions: {
        zoomSnap: 0.5,
        polygon: false,
        stroke: false,
        showCoverageOnHover: false,
      },
      attribution:
        '&copy; <a href="http://osm.org/copyright" target="_blank">OpenStreetMap</a> contributors',
    };
  },
  computed: {
    ...mapState([
      "showFilterPrintInStore",
      "showFilterLocker",
      "isPrintInStoreHighlighted",
      "isLockerHighlighted",
    ]),
    center: function () {
      const lat = this.parcelshopList[0].Adresse.Latitude || 47.41322;
      const long = this.parcelshopList[0].Adresse.Longitude || -1.219482;
      return latLng(lat, long);
    },
  },
  created() {
    window.L = L;
  },
  mounted() {
  this.$nextTick(() => {
      const interval = setInterval(() => {
        const mapElement = this.$refs.map.$el;
        if (mapElement.offsetWidth > 0 && mapElement.offsetHeight > 0) {
          clearInterval(interval); // Stoppe l'intervalle
          this.$refs.map.mapObject.invalidateSize();
        }
      }, 100); // Vérifie toutes les 100 ms
    });
  },
  methods: {
    isAmazonLocker,
    reloadMap() {
      // Fix the map if don't load
      this.$refs.map.mapObject.invalidateSize();
    },
    resetZoom() {
      this.zoom = 13;
    },
    computeCoordinates: function (coord) {
      return [coord.Adresse.Latitude, coord.Adresse.Longitude];
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },

    findNearestParcelshops: function (coord) {
      if (coord && coord.latlng) {
        this.$store.dispatch("findNearestParcelshops", {
          latitude: coord.latlng.lat,
          longitude: coord.latlng.lng,
          country: this.$store.state.userSelectedCountry,
        });
      }
      if (coord && coord.type === "moveend" && this.currentCenter) {
        //console.log(this.currentCenter, "centerupdate", coord);
      }
    },
    focusParcelshop: function (parcelshopId) {
      this.$store.dispatch("focusParcelshop", { parcelshopId });
      this.$emit("parcelshopSelected");
    },
    pictoHighlightClass: function (parcelshop) {
      if (isLocker(parcelshop)) {
        return "picto-locker";
      }
      let pictoClass = "picto-pink";
      
      if (this.showFilterPrintInStore) {
        if (
            this.isPrintInStoreHighlighted &&
            !parcelshop.Services.some((e) => e.Code === "PRINT")
          )
            pictoClass = "picto-grey";
      }
      
      if (this.showFilterLocker) {
        if (this.isLockerHighlighted && !isLocker(parcelshop))
            pictoClass = "picto-grey";
      }
      return pictoClass;
    },
    // getContainerClass: function (parcelshop) {
    //   if (parcelshop.CodeNature == "C") {
    //     return "locker-marker-container";
    //   } else {
    //     return "parcelshop-marker-container";
    //   }
    // },
    // pictoMarkerTextHighlightClass: function (parcelshop) {
    //   return "marker-text " + this.pictoHighlightClass(parcelshop);
    // },
    isVisible: function (parcelshop) {
      if (!this.isPrintInStoreHighlighted) {
        return true;
      }

      if (isLocker(parcelshop)) {
        return false;
      }

      return (
        parcelshop.Services &&
        parcelshop.Services.some((e) => e.Code === "PRINT")
      );
    },
  },
};
</script>

<style>
.map {
  height: 100%;
  min-height: 645px;
}

.picto-pink {
  background-size: contain;
}
.picto-grey {
  background-size: contain;
  filter: grayscale(100%);
}

.picto-locker {
  background-size: contain;
}

#marker-image {
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
  text-align: center;
}

.marker-text {
  z-index: 100;
  position: absolute;
  font-size: 15px;
  font-weight: bold;
  left: 50%;
  top: 15%;
  transform: translateX(-50%);
}

.marker-cluster {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 40px;
  color: #fff;
  font-family: "Montserrat";
  font-size: 12px;
  font-weight: 600;
  height: 26px !important;
  width: 26px !important;
}
</style>
